import React, { useEffect } from 'react'
import { useAuth } from '../../hooks/useAuth'


function Logout() {
    const { disconnect } = useAuth()

    useEffect(() => {
        disconnect()
    }, [])

    return (
        <div>Deconnexion ...</div>
    )
}

export default Logout